import React from 'react';
import './App.css';

function Home() {
  const projects = [
    {
      title: 'SSO - Create Account',
      url: 'https://my-sso.lucho-dev.xyz',
      description: 'Create your account to access all my applications with a single sign-on.',
      emoji: '🔐'
    },
    {
      title: 'Portfolio',
      url: 'https://portfolio.lucho-dev.xyz',
      description: 'My personal portfolio website showcasing my skills, projects, and professional experience.',
      emoji: '🎨'
    },
    {
      title: 'Flashcards',
      url: 'https://flashcards.lucho-dev.xyz',
      description: 'An interactive flashcard application designed for efficient learning and memorization.',
      emoji: '📚'
    },
    {
      title: 'F1 Dashboard',
      url: 'https://f1dashboard.lucho-dev.xyz',
      description: 'A real-time Formula 1 racing dashboard providing live race data and statistics.',
      emoji: '🏎️'
    },
    {
      title: 'My App',
      url: 'https://my-app.lucho-dev.xyz',
      description: 'A general-purpose application showcasing various React features and functionalities.',
      emoji: '📱'
    },
    {
      title: 'Max',
      url: 'https://max.lucho-dev.xyz',
      description: 'A specialized application project.',
      emoji: '🎮'
    },
    {
      title: 'Chicken Stude',
      url: 'https://chicken-stude.lucho-dev.xyz',
      description: 'A study-focused application with gamification elements to make learning more engaging.',
      emoji: '🐔'
    },
    {
      title: 'Quarto',
      url: 'https://quarto.lucho-dev.xyz',
      description: 'A strategic board game for two players. Align 4 pieces with at least one common characteristic to win!',
      emoji: '🎯'
    }
  ];

  return (
    <div className="App">
      <header className="App-header">
        <h1>Welcome to Lucho Dev</h1>
        <p className="tagline">Developer Portfolio & Projects Hub</p>
      </header>
      
      <main className="App-main">
        <section className="intro">
          <h2>About Me</h2>
          <p>
            Hi! I'm Louis Bertrand, a passionate developer creating innovative web applications.
            Explore my projects below to see what I've been working on.
          </p>
        </section>

        <section className="projects">
          <h2>My Projects</h2>
          <div className="projects-grid">
            {projects.map((project, index) => (
              <a
                key={index}
                href={project.url}
                className="project-card"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="project-emoji">{project.emoji}</div>
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <span className="project-link">Visit →</span>
              </a>
            ))}
          </div>
        </section>
      </main>

      <footer className="App-footer">
        <p>&copy; 2025 Louis Bertrand. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Home;
